import { createApp } from '@backstage/frontend-defaults';
import authPlugin from '@backstage/plugin-auth';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import { navModule } from './modules/nav';
import { themeModule, settingsModule } from './modules/theme';
import { hideScaffolderTabsModule } from './modules/hideScaffolderTabs';
import { oauthRequestDialogModule } from './modules/oauthRequestDialog';
import { pageTransitionModule } from './modules/pageTransition';
import { topBarModule } from './modules/topBar';
import { scaffolderWizardStyleModule } from './modules/scaffolderWizardStyle';
import { signInPageModule } from './modules/signInPage';
import { sessionTimeoutModule } from './modules/sessionTimeout';
import { actionToastModule } from './modules/actionToast';
import { rbacModule } from './modules/rbac';
import infrastructurePlugin from './plugins/infrastructure/plugin';
import { ociPickersModule } from './plugins/infrastructure/fieldExtensions';
import { runtimeExtensionPlugin } from './plugins/runtimeExtension/plugin';
import { notificationsPlugin } from './plugins/notifications/plugin';
import { homePlugin } from './modules/home/plugin';

// The loading screen shown while the app boots lives in
// public/index.html, not here — it has to render before this JS bundle
// even parses (and Backstage's sign-out flow does a full page reload, so
// that static splash is what actually covers every "loading" moment,
// including the one right after sign-out). A React-based
// `advanced.loadingElement` here would only ever render underneath that
// fixed, full-screen, higher-z-index splash — provably invisible — so
// there's deliberately no second implementation to keep in sync.

export default createApp({
  features: [
    authPlugin,
    userSettingsPlugin,
    signInPageModule,
    sessionTimeoutModule,
    actionToastModule,
    rbacModule,
    catalogPlugin,
    scaffolderPlugin,
    navModule,
    themeModule,
    settingsModule,
    hideScaffolderTabsModule,
    oauthRequestDialogModule,
    pageTransitionModule,
    topBarModule,
    scaffolderWizardStyleModule,
    infrastructurePlugin,
    ociPickersModule,
    runtimeExtensionPlugin,
    notificationsPlugin,
    homePlugin,
  ],
});
